import { createSelector } from 'reselect'
import { dataConstants } from 'services/redux/data/constants'
import ObjectEmployee from 'utils/objects/employee'

const selectEmployeeEros = createSelector(
	[
		(state) => {
			return state.data[dataConstants.EMPLOYEES_ERO];
		}
	],
	( employeesEro ) => {
		return ObjectEmployee.filterInvisible( employeesEro )
	}
)

export default selectEmployeeEros;